angular
	.module 'App.Repository'
.factory 'PredefinedLineitemDiscountRepository', ['BaseRepository', (BaseRepository) ->
	class PredefinedLineitemDiscountRepository extends BaseRepository
		@resource = '/predefined_lineitem_discounts'
		@isRestricted = true

		getPercentageText: (value) ->
			return parseFloat((value * 100).toFixed(3))

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'name', 'ASC'

			super query

	return new PredefinedLineitemDiscountRepository
]

